import React from 'react';
import Async from 'react-select/async';
import { currencyStore } from '../../../settings/currencies/CurrencyStore';
import { reactSelectAtsComponents } from 'ats/components/react-select/reactSelectAtsComponents';

export class CurrencyDropdown extends React.Component {
	render() {
		const { placeholder = 'Currency' } = this.props;

		return (
			<Async
				key={this.props.value ? this.props.value.id : 'empty'}
				menuPosition={this.props.menuPosition || 'fixed'}
				menuPlacement={this.props.menuPlacement || 'auto'}
				closeMenuOnScroll={this.props.closeMenuOnScroll}
				menuPortalTarget={this.props.menuPortalTarget}
				maxMenuHeight="300"
				className={
					'react-select ' +
					(this.props.styleVersion ? this.props.styleVersion : '') +
					(this.props.isInvalid ? ' has-error' : '')
				}
				classNamePrefix={
					this.props.classNamePrefix ||
					'react-select' +
						(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
				}
				cacheOptions
				value={this.props.value}
				placeholder={placeholder}
				isMulti={this.props.isMulti}
				isClearable={this.props.isClearable}
				isDisabled={this.props.disabled}
				components={
					this.props.styleVersion === 'ats'
						? reactSelectAtsComponents
						: undefined
				}
				styles={
					this.props.styleVersion === 'ats'
						? {
								container: (base, state) => ({
									...base,
									...(state.isDisabled && {
										opacity: 0.5,
										cursor: 'not-allowed'
									}),
									...(this.props.styles?.container?.(base, state) || {})
								}),
								control: (base, state) => {
									const next = {
										...base,
										paddingRight: 12,
										backgroundColor: '#FFFFFF',
										...(state.isFocused && {
											borderColor: '#6938EF',
											boxShadow: '0 0 0 1px #6938EF',
											backgroundColor: '#F4F3FF'
										}),
										'&:hover': {
											...base['&:hover'],
											borderColor: state.isFocused
												? '#6938EF'
												: base.borderColor,
											backgroundColor: '#F4F3FF'
										},
										...(this.props.customStyles?.control || {})
									};

									return this.props.styles?.control
										? this.props.styles.control(next, state)
										: next;
								},
								option: (base, state) => {
									const next = {
										...base,
										...(state.isFocused && {
											backgroundColor: '#F4F3FF'
										}),
										':active': {
											...base[':active'],
											backgroundColor: '#EBE9FE'
										}
									};

									return this.props.styles?.option
										? this.props.styles.option(next, state)
										: next;
								}
							}
						: this.props.styles
				}
				required={this.props.required}
				defaultOptions
				loadOptions={this.loadOptions}
				getOptionValue={this.getOptionValue}
				getOptionLabel={this.getOptionLabel}
				noOptionsMessage={this.noOptionsMessage}
				onChange={item => {
					if (this.props.onValueChange) {
						this.props.onValueChange(item);
					}
				}}
				{...this.props.AsyncProps}
			/>
		);
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getCurrencies(inputValue));
		});
	};

	getCurrencies = async inputValue => {
		inputValue = inputValue.trim();
		const result = await currencyStore.getCurrencies(inputValue);
		return result.data;
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search currencies';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.symbol} (${option.code})`;
}
